import { serviceMaker, methods, api } from "@/http/index.js";

export const getItemModel = () =>
  serviceMaker(`/modelprovisionmapping`, methods.GET, api.NGB);
export const getItemModelTemplate = () =>
  serviceMaker(`/modelprovisionmapping/template`, methods.GET, api.NGB);
export const createItemModel = (data) =>
  serviceMaker(`/modelprovisionmapping`, methods.POST, api.NGB, data);
export const getItemModelById = (id) =>
  serviceMaker(`/modelprovisionmapping/${id}`, methods.GET, api.NGB);
export const editItemModel = (id, data) =>
  serviceMaker(`/modelprovisionmapping/${id}`, methods.PUT, api.NGB, data);
export const deleteItemModel = (id) =>
  serviceMaker(`/modelprovisionmapping/${id}`, methods.DELETE, api.NGB);
